import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ 
    standalone:true,
    name: 'formatCell' 
})
export class FormatCellPipe implements PipeTransform {
    constructor (
        private date: DatePipe
    ) { }
    transform(value: any, format: string) {
        if ( value === undefined ) {
            return '-';
        }
        
        if (format === 'datetime') {
            //return this.date.transform(value, 'dd MMM yyyy | hh:mm aa');
            return this.date.transform(value, 'dd MMM yyyy | hh:mm aa', '+530');// timezone update as per IST
        }

        if(format == 'memberCount'){
            if(value > 1) {
                return value + " Members";
            }
            else if(value == 1){
                return value + " Member";
            }
            else return value;
        }
        
        return value;
    }
}